export type AutoCompleteAddresses = {
  predictions: { description: string; place_id: string }[];
};

export type UspsAddress = {
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  uspsMessage: string;
  county: string;
};

export type AddressComponents = {
  long_name: string;
  short_name: string;
  types: string[];
};

export type PlaceDetails = {
  results: {
    streetName: string;
    city: string;
    state: string;
    zip: string;
    lat: number;
    lng: number;
    county: string;
    address_components: AddressComponents[];
    formatted_address: string;
    geometry: {
      location: {
        lat: number;
        lng: number;
      };
      viewport: {
        northeast: {
          lat: number;
          lng: number;
        };
        southwest: {
          lat: number;
          lng: number;
        };
      };
    };
    formatted_phone_number: string;
    name: string;
    types: string[];
  }[];
};

export interface Address {
  organizationId?: number;
  fullAddress?: string;
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  county: string;
  zip: string;
}

export type AutoCompleteOption = {
  value: string;
  label: string;
};

export const defaultSelectedAddress = {
  fullAddress: "",
  address1: "",
  address2: null,
  city: "",
  state: "",
  county: "",
  zip: "",
};

export const defaultDeliveryAddress = {
  ...defaultSelectedAddress,
  organizationId: 0,
};

export const dummyAddress = {
  fullAddress: "123 Any Street, Columbus, OH, 43068",
  address1: "123 Any Street",
  address2: "",
  city: "Columbus",
  state: "OH",
  zip: "43068",
  county: "",
};

export interface AddressRef {
  handleResetAddressLookup: () => void;
  validateManualAddress: Function;
  isEnterManualAddress: boolean;
}

export type UspsAddresses = {
  homeAddress?: Address | null;
  mailingAddress?: Address | null;
  deliveryAddress?: Address | null;
};
